import AbstractDataBuilder from "../../core/AbstractDataBuilder";
import SwitchPricingNormalizersResolver from "./SwitchPricingNormalizersResolver";
export default class SwitchPricingDataBuilder extends AbstractDataBuilder {
    static create() {
        if (undefined === this.builderInstance) {
            this.builderInstance = new this(new SwitchPricingNormalizersResolver());
        }
        return this.builderInstance;
    }
}
